import { MentionLinkStyles } from './MentionLinkStyles'
import React from 'react'
import { MentionLinkProps } from './types/MentionLinkProps'

export const MentionLink = ({ children }: MentionLinkProps): JSX.Element => {
  // TODO: handle href
  return <span className={'MentionLink ' + MentionLinkStyles}>{children}</span>
}
